module.exports = __webpack_public_path__ + "img/clem-onojegaw.8f92b88b.jpg";